// extracted by mini-css-extract-plugin
export var caption = "styles-module--caption--de77d";
export var link = "styles-module--link--fdb6d";
export var linkContent = "styles-module--linkContent--e6841";
export var linkIcon = "styles-module--linkIcon--e104f";
export var linkTitleAndIcon = "styles-module--linkTitleAndIcon--a6575";